import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalBaseComponent, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { CoreService, ResourceModel } from 'src/app/services/api-services';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;
@Component({
    selector: 'app-frontend-display-html-edit',
    templateUrl: './frontend-display-html-edit.component.html',
    styleUrls: ['./frontend-display-html-edit.component.scss'],
})
export class FrontendDisplayHtmlEditComponent extends ModalBaseComponent {
    showModal: boolean = true;

    constructor(private bsModalRef: BsModalRef, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, private translatedToastrService: TranslatedToastrService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public title: string;
    public item: ResourceModel;

    public key: string;
    public value: string;

    private getFormGroup(): FormGroup {
        return new FormGroup({
            id: new FormControl({ value: '', disabled: true }),
            language: new FormControl({ value: '', disabled: true }),
            key: new FormControl({ value: '', disabled: true }),
            value: new FormControl(''),
        });
    }

    public form: FormGroup = this.getFormGroup();

    public ngOnInit() {
        if (this.item) {
            this.form.patchValue(this.item);
        }
    }

    public ngAfterViewInit() {
        this.initSummerNote();
    }

    public async initForm() {
        this.form = this.getFormGroup();
    }

    public initSummerNote() {
        $('#summernote').summernote({
            height: 400,
            tooltip: true,
            tabsize: 2,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'picture', 'video', 'table']],
                ['view', ['codeview', 'help']],
            ],
            callbacks: {
                onChange: (contents: string) => {
                    this.form.controls['value'].setValue(contents);
                },
            },
        });

        $('#summernote').summernote('code', this.value);
    }

    public onSave = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            let formValues = <ResourceModel>this.form.getRawValue();
            formValues.value = this.cleanHtml(formValues.value);

            return this.handleSpinner(
                firstValueFrom(this.coreService.updateHtmlResource(formValues))
                    .then(res => {
                        this.onClose(this.bsModalRef, 'save_success');
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                    })
            );
        }
    };

    private cleanHtml(bodyValue: string): string {
        let cleanedBodyValue = bodyValue
            .replace(/\n+/g, '')
            .replace(/\r+/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim();

        return cleanedBodyValue;
    }
}
